module.exports = __webpack_public_path__ + "img/resize.bf671134.svg";